<template>
  <page style="height: 100vh; overflow: hidden">
    <template v-if="isScan && cabinet && !isBtns">
      <div slot="nav" class="page-head-default">
        <img
          src="../assets/imgs/icon_drawer.png"
          alt=""
          @click="isMenuView = true"
        />
        {{ title }}
      </div>
    </template>
    <div v-else class="home-head" @click="isMenuView = true">
      <!-- <div class="home-logo">
        <img src="../assets/imgs/img_logo.png" alt="" />
      </div> -->
      <div class="home-head-title">
        <p class="home-head-title-small">Welcome to</p>
        <p class="home-head-title-big">{{ title }}</p>
      </div>
    </div>
    <div>
      <div class="home-warp" v-if="isScan && cabinet && !isBtns">
        <div class="banner" :style="banner"></div>
        <div class="home-warp-main">
          <div class="home-warp-block"></div>
          <div class="home-warp-cont">
            <div class="home-warp-title">
              <img src="../assets/imgs/map.png" alt="" />
              <span>{{ cabinet.shopname }}</span>
            </div>
            <div class="home-warp-jifei">
              <span>
                {{ cabinet.currencyName }}{{ $moneyFormat(cabinet.jifei) }}
              </span>
              /
              {{ cabinet.jifeiDanwei }}{{ $priceUnit(priceStrategy.priceUnit) }}
            </div>
            <div class="home-warp-row">{{ shopDesc }}</div>
            <div class="home-warp-row">{{ shopDesc0 }}</div>
            <div class="home-warp-row">{{ shopDesc1 }}</div>
            <div class="home-warp-row">{{ shopDesc2 }}</div>
            <!-- <div class="home-warp-row">
              <img src="../assets/imgs/icon_phone.png" alt="" />
              {{ i18n.feature_1 }}
            </div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_star.png" alt="" />
              {{ i18n.feature_2 }}
            </div> -->
            <!-- <div class="home-warp-row">
              <img src="../assets/imgs/icon_tag.png" alt="">
              {{i18n.feature_3}}
            </div> -->
          </div>
          <div class="home-warp-btn">
            <!-- <div class="home-warp-btn" v-if="cabinet.chongzhi === 'Y'"> -->
            <!-- <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips1 }}</span>
            </div> -->
            <!-- <div
              class="btn"
              v-if="cabinet.yajintype === 0 && cabinet.yajin > 0"
              @click="onSubmit"
            >
              {{ i18n.preauth }}
            </div> -->
            <div class="btn" @click="onSubmit">
              {{ i18n.borrow }}
            </div>
          </div>
          <!-- <div class="home-borrow-tips" @click="onPaymentAgreement">{{ i18n.borrow_tips }}</div>
          <div class="home-pay-icon">
            <img src="@/assets/imgs/icon_mastercard.png" alt="" @click="goRouter('https://www.mastercard.com')">
            <img src="@/assets/imgs/icon_maestro.png" alt="" @click="goRouter('https://brand.mastercard.com/brandcenter/more-about-our-brands.html')">
            <img src="@/assets/imgs/icon_visv.png" alt="" @click="goRouter('https://www.visaeurope.com')">
            <img src="@/assets/imgs/icon_idcheck.png" alt="" @click="goRouter('https://www.mastercard.com')">
            <img src="@/assets/imgs/icon_secure.png" alt="" @click="goRouter('https://www.visaeurope.com')">
            <img src="@/assets/imgs/icon_monri.png" alt="" @click="goRouter('http://monri.com/')">
          </div>
          <div class="home-info-card">
            <div class="home-info-list">
              <div class="home-info-row">
                <img src="@/assets/imgs/icon_company.png" alt="">
                <span>{{ i18n.company_name }}</span>
              </div>
              <div class="home-info-row">
                <img src="@/assets/imgs/icon_address3.png" alt="">
                <span>{{ i18n.company_address }}</span>
              </div>
            </div>
            <div class="home-info-list">
              <div class="home-info-row">
                <img src="@/assets/imgs/icon_phone2.png" alt="">
                <span>{{ i18n.company_phone }}</span>
              </div>
              <div class="home-info-row">
                <img src="@/assets/imgs/icon_email.png" alt="">
                <span>{{ i18n.company_email }}</span>
              </div>
              <div class="home-info-row">
                <img src="@/assets/imgs/icon_id.png" alt="">
                <span>{{ i18n.company_id }}</span>
              </div>
              <div class="home-info-row">
                <img src="@/assets/imgs/icon_tax.png" alt="">
                <span>{{ i18n.company_vat }}</span>
              </div>
            </div>
          </div> -->
          <!-- <div class="home-warp-btn" v-else>
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips3 }}</span>
            </div>
            <!- <div class="btn" @click="onBorrow">{{ i18n.borrow }}</div> ->
          </div> -->
        </div>
      </div>
      <div v-else>
        <img class="home-bg" :src="homebg" alt="" />
        <div class="home-foot">
          <div class="home-btns">
            <template v-if="!code">
              <a
                v-if="system === 'ios'"
                style="background: #fff"
                @click="onAppStore"
              >
                <img src="../assets/imgs/icon_applepay.png" alt="" />
                <span>App Store</span>
              </a>
              <a v-else style="background: #fff" @click="onGooglePlay">
                <img src="../assets/imgs/icon_google.png" alt="" />
                <span>Google Play</span>
              </a>
            </template>
            <div class="downloaddark" v-else>
              <div class="icondark">
                <img
                  src="../assets/imgs/appstore_dark.png"
                  @click="onAppStore"
                  alt=""
                />
                <img
                  src="../assets/imgs/googleplay_dark.png"
                  @click="onGooglePlay"
                  alt=""
                />
              </div>
              <div class="next" @click="onCode">
                <div class="text">NEXT</div>
                <img src="../assets/imgs/icon_next.png" alt="" />
              </div>
              <!-- <a class="next" v-if="code" @click="onCode">
                <span>{{i18n.goborrow}}</span>
              </a> -->
            </div>
          </div>
          <!-- <span class="nearby" @click="goNearby">{{i18n.nearby}} ></span> -->
        </div>
      </div>
      <popup-warp v-model="isMenuView" dialogTransition="slide-left">
        <menu-side @close="isMenuView = false"></menu-side>
      </popup-warp>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex";
import { PopupWarp } from "../components/popup";
import { MenuSide } from "../components/menu";
import { QR_CODE, ZH_CODE } from "../apis/cabinet";
import { USER_INFO, USER_CARD } from "../apis/user";
import { SAVED_CARD_TO_RENT } from "../apis/payment";

export default {
  components: {
    PopupWarp,
    MenuSide
  },
  computed: {
    ...mapState([
      "qrcode",
      "zhcode",
      "cabinet",
      "browser",
      "user",
      "token",
      "system"
    ]),
    i18n() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    title() {
      return process.env.VUE_APP_NAME;
    },
    code() {
      return this.qrcode || this.zhcode;
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}&usePriceUnit=true`;
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`;
      }
      return "";
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : "";
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format({
        ...this.cabinet,
        fengding: this.$moneyFormat(this.cabinet.fengding),
        yajin: this.$moneyFormat(this.cabinet.yajin),
        appName: process.env.VUE_APP_NAME
      });
    },
    shopDesc0() {
      return `${this.i18n.price_info_0}`.format({});
    },
    shopDesc1() {
      return `${this.i18n.price_info_1}`.format({
        ...this.cabinet,
        ...this.cabinet.priceStrategy
      });
    },
    shopDesc2() {
      return `${this.i18n.price_info_2}`.format({
        email: process.env.VUE_APP_EMAIL,
        appName: process.env.VUE_APP_NAME
      });
    },
    shopTips1() {
      return `${this.i18n.tips_1}`.format(this.cabinet);
    },
    shopTips2() {
      return `${this.i18n.tips_2}`.format(this.cabinet);
    },
    shopTips3() {
      return `${this.i18n.tips_3}`.format(this.cabinet);
    },
    homebg() {
      return `${process.env.VUE_APP_DOMAIN}/content/introduction1.png`;
    },
    amount() {
      if (this.cabinet) {
        const { yajin, myyue } = this.cabinet;
        // 余额不足押金时只需补足差额
        return Math.max(yajin - myyue, 0).toFixed(2);
      } else {
        return 0;
      }
    },
    priceStrategy() {
      // 缓存的 cabinet 可能缺 priceStrategy 字段,兜底空对象防止渲染崩溃
      return (this.cabinet && this.cabinet.priceStrategy) || {};
    }
  },
  data() {
    return {
      isMenuView: false,
      isScan: false,
      isBtns: false,
      checked: true,
      adVisible: false,
      downloadApp: false,
      downType: "",
      cardList: [] // 已保存的支付卡列表
    };
  },
  methods: {
    Download(str) {
      this.downloadApp = true;
      this.downType = str;
    },
    onDownload() {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY;
      if (this.system === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE;
      }
      if (dowmloadUrl) {
        window.open(dowmloadUrl);
      } else {
        this.$toast(this.i18nMsg.appoffline);
      }
    },
    onScan() {
      if (!this.scanUrl) return;
      this.$loading(true);
      this.$post(
        this.scanUrl,
        {},
        resp => {
          this.$loading(false);
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          });
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order");
                this.$store.commit("qrcode", "");
              })
              .catch(() => {
                this.$store.commit("qrcode", "");
              });
          } else {
            this.isScan = true;
            this.isBtns = false;
            this.adVisible = true;
          }
        },
        error => {
          this.$loading(false);
          this.$toast(error);
        }
      );
    },
    onSubmit() {
      const { yajin, myyue, overtimeAmount } = this.cabinet;
      // 余额能同时覆盖押金和超时金额时,无需强制绑卡
      const balanceEnough = myyue >= yajin && myyue >= overtimeAmount;
      // 押金为0但有超时金额:强制保存卡,走卡授权模式,否则后续超时扣不到款
      if (!balanceEnough && yajin === 0 && overtimeAmount > 0) {
        if (this.cardList && this.cardList.length > 0) {
          this.saveToRent();
        } else {
          this.$router.push({
            path: "/payment_card",
            query: { payType: "YJ", qrcode: this.cabinet.qrcode }
          });
        }
        return;
      }
      // 超时金额大于押金:强制保存卡,走增量预授权模式
      if (
        !balanceEnough &&
        yajin > 0 &&
        overtimeAmount > 0 &&
        overtimeAmount > yajin
      ) {
        if (this.cardList && this.cardList.length > 0) {
          this.$router.push({
            path: "/confirm",
            query: {
              price: this.amount,
              payType: "YJ",
              cabinetID: this.cabinet.qrcode,
              yaJinType: this.cabinet.yajintype,
              forceCard: true
            }
          });
        } else {
          this.$router.push({
            path: "/payment_card",
            query: { payType: "YJ", qrcode: this.cabinet.qrcode }
          });
        }
        return;
      }
      // 默认进支付确认页,差额>0走支付,差额为0时由用户在确认页手动确认后余额租借,不再静默直租
      this.$router.push({
        path: "/confirm",
        query: {
          price: this.amount,
          payType: "YJ",
          cabinetID: this.cabinet.qrcode,
          yaJinType: this.cabinet.yajintype
        }
      });
    },
    // 已保存卡直接租借(卡授权模式)
    saveToRent() {
      this.$loading(true);
      this.$get(
        `${SAVED_CARD_TO_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode
        },
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data && resp.data.out_trade_no) {
            this.$router.replace(
              `/result?payMode=stripe&tradeNo=${resp.data.out_trade_no}`
            );
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    },
    // 获取用户已保存的支付卡
    async getUserPayCard() {
      this.$loading(true);
      const qrcode = this.qrcode || (this.cabinet && this.cabinet.qrcode);
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode,
        orderId: "",
        agentld: this.agentId
      })
        .catch(error => {
          this.$loading(false);
          console.log(error);
        })
        .finally(() => {
          this.$loading(false);
        });
      let cardList = [];
      if (data && data.length) {
        cardList = data.map(item => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item
          };
        });
        this.cardList = cardList;
      }
      return cardList;
    },
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit("user", resp.user);
            this.onScan();
          } else {
            this.$store.commit("user", null);
          }
        },
        error => {
          this.$store.commit("user", null);
          console.log(error);
        }
      );
    },
    onAppStore() {
      console.log("11111");
      window.open(process.env.VUE_APP_APP_STORE);
      // window.location.href = process.env.VUE_APP_APP_STORE
    },
    onGooglePlay() {
      console.log("22222");
      window.open(process.env.VUE_APP_GOOGLE_PLAY);
      // window.location.href = process.env.VUE_APP_GOOGLE_PLAY
    },
    onCode() {
      this.isBtns = false;
      this.loadUser();
    },
    onEntrust() {
      console.log("test", process.env.VUE_APP_DOMAIN_NAME);
      window.location.href = `${process.env.VUE_APP_DOMAIN_NAME}/content/wxf_auth.html`;
    },
    goNearby() {
      this.$router.push("./google_map");
    },
    setDocumentTitle(title) {
      document.title = title;
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement("iframe");
        i.src = "/favicon.ico";
        i.style.display = "none";
        i.onload = function() {
          setTimeout(function() {
            i.remove();
          }, 9);
        };
        document.body.appendChild(i);
      }
    },
    // 获取用户支付卡信息
    onPaymentAgreement() {
      window.open("https://m.chargi.ba/content/payment_agreement.html");
    },
    goRouter(path) {
      window.open(path);
    }
  },
  created() {
    console.log("类型", this.browser, "1");
    this.isBtns = true;
    if (this.$route.query && this.$route.query.cabinetshow === "true") {
      this.isScan = true;
      this.isBtns = false;
      this.adVisible = true;
    }
    // this.loadUser()
    // if (!this.isBtns && this.code) {
    //   this.loadUser()
    // }
  },
  mounted() {
    if (this.user || this.token) this.getUserPayCard();
  }
};
</script>

<style lang="less">
.home-head {
  width: 100%;
  font-size: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  // margin: 20px 0 0;
  padding: 0 46px 0 0;

  .home-logo {
    padding-top: 120px;
    width: 428px;
    height: 269px;
    background-color: #31b3ff;
    border-radius: 0 0 294px 0;
    img {
      display: block;
      margin: 0 auto;
      width: 322px;
    }
  }

  &-title {
    p {
      text-align: end;
      margin: 10px 0;
    }

    &-small {
      font-family: "Montserrat-Medium";
      font-size: 24px;
      color: #171917;
    }

    &-big {
      font-family: "Montserrat-SemiBold";
      font-size: 36px;
      font-weight: 500;
      color: #000;
    }
  }
}

.home-warp {
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #000;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }

  &-main {
    width: 100%;
    // height: calc(100vh - 484px);
    position: fixed;
    bottom: 0;
    left: 0;
    padding-bottom: 48px;
    background: #000;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
    overflow: auto;
  }

  &-block {
    display: flex;
    justify-content: center;
    align-items: center;

    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }

  &-cont {
    padding: 0 48px;
  }

  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }

  &-jifei {
    padding: 60px 0 20px;
    font-size: 36px;
    font-weight: 600;

    span {
      font-size: 60px;
    }
  }

  &-row {
    display: flex;
    font-size: 24px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    color: #999999;

    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }

  &-btn {
    // position: fixed;
    // left: 48px;
    // right: 48px;
    // bottom: 48px;
    margin: 40px 48px 0;

    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
    .downloadbtn {
      color: #333;
      margin-bottom: 24px;
      background-color: #67c23a;
    }
  }

  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 28px;
    color: #666666;
    padding: 20px 0;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }

  .home-borrow-tips {
    font-size: 28px;
    color: #8b8b8b;
    padding: 30px 40px;
    text-align: center;
  }
  .home-pay-icon {
    display: flex;
    justify-content: center;
    img {
      display: block;
      height: 46px;
      margin: 0 14px;
    }
  }
  .home-info-card {
    display: flex;
    padding: 30px 20px;
    .home-info-list {
      flex: 1;
      .home-info-row {
        display: flex;
        color: #8b8b8b;
        font-size: 22px;
        align-items: center;
        padding: 10px 0;
        img {
          width: 28px;
          height: 28px;
          display: block;
          margin: 0 14px;
        }
      }
    }
  }
}

.home-bg {
  width: 60%;
  display: block;
  margin: 0px auto;
  // height: 100vh;
}

.home-btns {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 40px;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  z-index: -1;

  a {
    text-decoration: none;
    width: 30%;
    flex: 1;
    margin: 20px;
    background: #fff;
    color: #000000;
    padding: 20px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}

.downloaddark {
  display: flex;
  justify-content: space-between;
  margin: 0 60px;

  .icondark {
    width: 40%;

    img {
      display: block;
      width: 90%;
    }

    img:last-child {
      margin-top: 20px;
    }
  }

  .next {
    width: 40%;
    font-family: "DIN Condensed Bold";
    font-size: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: #73d146;
    border-radius: 20px;
    padding: 0px 20px;

    .text {
      // line-height: 64px;
      display: block;
    }

    img {
      width: 64px;
      height: 64px;
      margin-left: 20px;
      vertical-align: middle;
    }
  }
}

.go-code {
  text-align: center;
  color: #67c23a;
  text-decoration: underline;
  padding: 10px 0 30px;
}

.home-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;

  .nearby {
    position: absolute;
    bottom: 170px;
    right: 20px;
    color: #fff;
    text-decoration: underline;
    text-align: center;
  }
}

.borrow-wechat-zff {
  display: flex;
  justify-content: center;
  padding: 20px 0 4px;

  img {
    height: 34px;
  }
}

.home-checkbox {
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 18px;

  .home-checkbox-text {
    color: #52ac7a;
  }

  input[type="checkbox"] {
    cursor: pointer;
    position: relative;
  }

  input[type="checkbox"]::after {
    position: absolute;
    top: 0;
    background-color: #fff;
    color: #fff;
    width: 28px;
    height: 28px;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: " ";
    border-radius: 4px;
    box-sizing: border-box;
    border: 2px solid #ddd;
  }

  input[type="checkbox"]:checked::after {
    content: "";
    background-color: #52ac7a;
    border-color: #52ac7a;
    background-color: #52ac7a;
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 10px;
    width: 6px;
    height: 16px;
    border: solid white;
    border-width: 0 4px 4px 0;
    transform: rotate(45deg);
    z-index: 1;
  }
}

.home-mine {
  width: 90px;
  height: 60px;
  line-height: 30px;
  padding: 15px 0;
  font-size: 28px;
  text-align: center;
  position: fixed;
  right: 40px;
  bottom: 350px;
  z-index: 99;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 8px 24px 0 rgba(52, 125, 255, 0.32);
  // img {
  //   width: 100%;
  //   height: 100%;
  //   border-radius: 50%;
  // }
}
</style>
